import { FieldType } from 'components/organisms/tasks/fields';
import { ProjectFieldsName } from '../../fields';
import { dueDateKeyCreator } from './due-date';
import { inferredProgressKeyCreator } from './inferred-progress';
import { pastProjectStatusKeyCreator } from './last-5-status-update';
import { singleSelectKeyCreator } from './single-select';
import { startDateKeyCreator } from './start-date';
import { GetKeyCreatorFunction } from './types';

export const getKeyCreator: GetKeyCreatorFunction = (field) => {
  switch (field.type) {
    case FieldType.Date:
      switch (field.fieldName) {
        case 'startDate':
          return startDateKeyCreator;
        case 'dueDate':
          return dueDateKeyCreator;
        default:
          return undefined;
      }
    case FieldType.SingleUser:
    case FieldType.SingleSelect:
      switch (field.fieldName) {
        case ProjectFieldsName.inferredProgress:
          return inferredProgressKeyCreator;
        case ProjectFieldsName.pastProjectStatus:
          return pastProjectStatusKeyCreator;
        default:
          return singleSelectKeyCreator;
      }
    case FieldType.Assignee:
    case FieldType.Text:
    case FieldType.Number:
    case FieldType.MultiSelect:
    case FieldType.MultiUser:
    case FieldType.Estimate:
    case FieldType.Boolean:
    default:
      return undefined;
  }
};
